import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { BaryModalService } from '../../../../../../services/bary-modal.service';
import { BaryButtonComponent } from '../../../../components';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'jhi-bary-table-manager-action-button',
  templateUrl: './bary-table-manager-action-button.component.html',
  styleUrls: ['./bary-table-manager-action-button.component.scss'],
  imports: [BaryButtonComponent, TranslateModule, NgIf, RouterLink],
  standalone: true,
})
export class BaryTableManagerActionButtonComponent<T> {
  readonly #modalService = inject(BaryModalService);

  @Input() items?: T & { position?: number }[];
  @Input() tableOptions!: TableOptions;

  @Output() newEvent = new EventEmitter();
  @Output() newAndRedirectEvent = new EventEmitter();

  public openAddNew(redirect: boolean): void {
    if (this.tableOptions.createModalLabel) {
      (this.#modalService as any)
        [this.tableOptions.createModalLabel]()
        .action()
        .subscribe((action: { submit: any; value: any }) => {
          if (action.submit) {
            if (redirect) {
              this.newAndRedirectEvent.emit(action.value);
            } else {
              this.newEvent.emit(action.value);
            }
          }
        });
    }
  }
}
